import { Button } from '@/components/ui/button';

import type { KickOutComment } from '../types';

interface KickOutCommentPickerProps {
  comments: KickOutComment[];
  description: string;
  onSelect: (comment: string) => void;
}

export function KickOutCommentPicker({
  comments,
  description,
  onSelect,
}: KickOutCommentPickerProps) {
  if (comments.length === 0) return null;

  const selectedParts = description
    .split(' - ')
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <div className="flex flex-col gap-1">
      <span className="text-muted-foreground text-xs font-medium">
        Quick Reasons
      </span>
      <div className="flex flex-wrap gap-1">
        {comments.map((c) => (
          <Button
            key={c.commentId}
            variant={
              selectedParts.includes(c.commentName) ? 'default' : 'outline'
            }
            size="xs"
            onClick={() => onSelect(c.commentName)}
          >
            {c.commentName}
          </Button>
        ))}
      </div>
    </div>
  );
}
